import React from 'react';
import { replaceTemplateWithElements, useLanguageStore } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import styles from './index.module.scss';

/** 沿用旧首页域名备案配置，测试域名和本地环境回退到 .com。 */
export function getHomeFooterInfo(hostname: string) {
  const isCn = hostname === 'roboneo.cn' || hostname.endsWith('.roboneo.cn');
  return {
    license: isCn ? '闽B2-20040192-102' : '闽B2-20040192-92',
    email: isCn ? 'support@roboneo.cn' : 'support@roboneo.com',
  };
}

/** 新版首页页脚：独立于登录与精选请求，复用既有 Smartcat 备案及联系文案。 */
export default function HomeFooter() {
  const language = useLanguageStore((state) => state.languageStore);
  const isOversea = useOfficialStore((state) => state.isOversea());
  const { license, email } = getHomeFooterInfo(typeof window === 'undefined' ? '' : window.location.hostname);
  return (
    <footer className={styles.footer}>
      {!isOversea && <div>{language.smartcatTranslationText((v) => v.roboneo_web_license_1)}</div>}
      <div>
        {replaceTemplateWithElements(isOversea ? 'roboneo_web_connect_overseas' : 'roboneo_web_connect', {
          license: <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">{license}</a>,
          support_email: <a href={`mailto:${email}`}>{email}</a>,
          api_email: <a href="mailto:aigc@meitu.com">aigc@meitu.com</a>,
        })}
      </div>
    </footer>
  );
}
